"use strict";

angular.module("vendor")
.controller("SupportVendorListController", function($timeout, $scope, $state, $stateParams, UserService, SupportVendorService) {
    var _this = this;
    $scope.params = angular.extend({}, $stateParams);
    $scope.pagination = {};

    this.fetch = function() {
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        SupportVendorService.query($scope.params).$promise
        .then(function onSuccess(data) {
            $scope.pagination = data.pagination;
            $scope.vendors = data.results;
        })
    };

    this.impersonate = function(vendor_id) {
        SupportVendorService.impersonate(vendor_id).$promise
        .then(function onSuccess() {
            UserService.refreshCurrentUser().then(function() {
                $state.go("home");
            });
        });
    };

    this.fetch();

    $scope.$on("queryListing", function($event, params) {
        angular.extend($scope.params, params);
        _this.fetch();
    });
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/support/support-vendor-list.controller.js
// module id = 1014
// module chunks = 0